export default __webpack_public_path__ + "static/media/999467111882a2a26ab0c6f3a3a21d94.svg";